import { FC } from 'react';

import { PlaceholderBar } from '../../components/loading-skeleton/index';

type PerksPlaceholderProps = {
  cards?: number;
};

export const PerksPlaceholder: FC<PerksPlaceholderProps> = ({ cards = 6 }) => (
  <div className="grid h-fit w-full animate-pulse grid-cols-[repeat(auto-fill,minmax(400px,1fr))] gap-4 max-lg:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]">
    {Array.from({ length: cards }).map((_, index) => (
      <div
        className="flex h-[500px] w-full flex-col gap-4 overflow-hidden rounded-lg border border-gray-200 pb-6"
        key={index}
      >
        <PlaceholderBar className="h-[245px] w-full rounded-none bg-gray-100" />
        <div className="flex flex-col gap-2 px-6">
          <PlaceholderBar className="h-3 w-24 rounded bg-gray-100" />
          <PlaceholderBar className="h-6 w-3/4 rounded bg-gray-100" />
          <PlaceholderBar className="h-4 w-full rounded bg-gray-100" />
        </div>
        <div className="mt-auto flex items-center gap-2 px-6">
          <PlaceholderBar className="size-8 rounded-full bg-gray-100" />
          <PlaceholderBar className="h-4 w-28 rounded bg-gray-100" />
        </div>
      </div>
    ))}
  </div>
);
